"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var request_1 = __importDefault(require("../request"));
var baseUrl = 'https://retail-client-events-service.internal.salsify.com';
var eventsEndpoint = "".concat(baseUrl, "/events");
var LogTransport = /** @class */ (function () {
    function LogTransport(clientId, sessionId, pageSessionId) {
        this.clientId = clientId;
        this.sessionId = sessionId;
        this.pageSessionId = pageSessionId;
    }
    LogTransport.prototype.log = function (code, properties, context) {
        var event = {
            code: 'sdk_' + code,
            properties: properties,
            context: context,
            timestamp: Date.now() / 1000,
        };
        this.send([event]);
    };
    LogTransport.prototype.send = function (logs) {
        var payload = {
            app: 'sxp_sdk',
            channel: this.clientId,
            csid: this.sessionId,
            pagesessionid: this.pageSessionId,
            timestamp: Date.now() / 1000,
            logs: logs,
        };
        request_1.default.post(eventsEndpoint, payload);
    };
    return LogTransport;
}());
exports.default = LogTransport;
//# sourceMappingURL=log-service-transport.js.map